import React from 'react';
import clsx from 'clsx';

/**
 * The action row for a footerless form.
 *
 * BaseForm's actions sit in a fixed `glass-bar` footer, which only works when
 * the form owns the whole viewport. A settings tab body does not, so its buttons
 * live inline - but at the same gap and alignment, so the two read as one system.
 *
 * `align="between"` mirrors BaseForm's back-button layout: a left slot pushed
 * away from the primary actions.
 */

export interface FormActionsProps {
  /** Left-hand slot (a Back button, a destructive action, a hint). */
  leading?: React.ReactNode;
  align?: 'end' | 'between';
  /** Adds the hairline divider above the row. */
  divider?: boolean;
  className?: string;
  children: React.ReactNode;
}

const FormActions: React.FC<FormActionsProps> = ({
  leading,
  align = 'end',
  divider = false,
  className,
  children,
}) => (
  <div
    className={clsx(
      'flex items-center gap-2 pt-4',
      divider && 'border-t border-hairline-soft',
      leading || align === 'between' ? 'justify-between' : 'justify-end',
      className
    )}
  >
    {leading && <div className="flex items-center gap-2">{leading}</div>}
    <div className="flex items-center gap-2">{children}</div>
  </div>
);

export default FormActions;
